/**
 * Fix malformed scheme-less URLs.
 * Some production data had `R2_PUBLIC_URL` env stored without the colon
 * after `https`, producing URLs like `https//pub-...r2.dev/foo.jpg`. The
 * browser treats those as relative paths and prepends the current origin.
 *
 * This helper repairs the URL just-in-time before rendering.
 */
export const fixImageUrl = (url) => {
  if (typeof url !== 'string') return url;
  // Strip any accidentally-prepended host like "https://host/https//pub-..." → "https://pub-..."
  for (const marker of ['https//', 'http//']) {
    const idx = url.indexOf(marker, 1);
    if (idx > 0) {
      const inner = url.slice(idx);
      if (inner.startsWith('https//')) return 'https://' + inner.slice('https//'.length);
      if (inner.startsWith('http//')) return 'http://' + inner.slice('http//'.length);
    }
  }
  if (url.startsWith('https//')) return 'https://' + url.slice('https//'.length);
  if (url.startsWith('http//')) return 'http://' + url.slice('http//'.length);
  return url;
};
